import { render, staticRenderFns } from "./social-feed.vue?vue&type=template&id=6c143b63&scoped=true"
import script from "./social-feed.vue?vue&type=script&lang=js"
export * from "./social-feed.vue?vue&type=script&lang=js"
import style0 from "./social-feed.vue?vue&type=style&index=0&id=6c143b63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c143b63",
  null
  
)

export default component.exports